import { Button, IconButton, InputAdornment, TextField } from "@mui/material";
import React, { useCallback, useState } from "react";
import Scanner from "../Scanner/Scanner";
import { useTranslation } from "react-i18next";
// import { parseUDI } from "../../utils/scannerHelper";
// import { isProductBlade } from "../HuItem/HuItem";
// import { Configuration, ProductApi, ProductBlade } from "../../api/product/generated/src";
import { useSnackbar } from "../snackbar";
import { useNavigate } from "react-router";
// import { HandlingUnitApi } from "../../api/warehouse/generated/src";
import { BsCamera, BsQrCodeScan, BsSearch, BsUpcScan } from "react-icons/bs";
import { MobileInlineScanner } from "../Scanner/MobileInlineScanner";
import { MobileInlineScannerV2 } from "../Scanner/MobileInlineScannerV2";

interface IMultiScanFormProps {
    checkScan: (scanned:string) => Promise<string | null>;
    runSearch: (scanned:string) => Promise<boolean>;

    defaultActive?: boolean;

    inputLabel?: string;
}

const MultiScanForm = (props:IMultiScanFormProps) => {

    const showSnackbar = useSnackbar();
    
    // const navigate = useNavigate();
    
    const { checkScan, runSearch } = props;
   


    const handleSubmit = () => {
        // setSearchValue(inputValue);
        searchCallback(inputValue);
    }


    const search = async (searchStr:string) => {
        if(searchStr){
            const success = await runSearch(searchStr);

            // const hu = await getHu(searchStr);
    
            // if(hu){
            //     navigate(`/t/${hu.id}`);
            // }
            // else{
            //     const article = await getArticle(searchStr);
    
            //     if(article){
            //         navigate(`/m/${article.id}`);
            //     }
            //     else{
            //         showSnackbar("Material oder Fach nicht gefunden", 'error');
            //     }
    
            // }
        }
        else{
            showSnackbar("Keine Eingabe vorhanden", 'error');
        }
    }

    const searchCallback = useCallback(search, [runSearch, showSnackbar]);


   

    const handleScanned = async (scanned: string) => {

        console.log("scanned:", scanned);

        const scannedID = await checkScan(scanned);

        

        if(scannedID) {
            // ermittelte ID
            setInputValue(scannedID);
            searchCallback(scannedID);
        }
        else{
            // nur der gescannte Wert
            setInputValue(scanned);
        }
    }

    const handleScannedCallback = useCallback(handleScanned, [checkScan, searchCallback])

    const { t } = useTranslation();

    const [inputValue, setInputValue] = useState<string>("");
    const [scannerActive, setScannerActive] = useState<boolean>(props.defaultActive ?? false);



    return (
        <>
            <div className="flex space-x-3">
                <div className="flex-1 relative">
                {/* <BsSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" /> */}
                <TextField
                    type="text"
                    // placeholder="Artikel-ID eingeben oder scannen"
                    placeholder={props.inputLabel ?? ""}
                    value={inputValue}
                    onChange={(event) => {
                        const value = event.target.value;
                        
                        setInputValue(value)
                    }}
                    variant="outlined" 
                    fullWidth

                    sx={{ backgroundColor: 'background.paper' }}

                    InputProps={
                        {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        edge="end"
                                        size="small"
                                        color="primary"
                                        aria-label="Suche starten"
                                        onClick={() =>{
                                            handleSubmit()
                                        }}
                                    >
                                        <BsSearch />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }
                    }

                                       
                    // className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                </div>
                <Button
                    variant="contained" 
                    color="primary"

                    onClick={() => setScannerActive(!scannerActive)}
                    className={`px-4 py-3 rounded-lg font-medium transition-all ${
                        scannerActive 
                        ? 'bg-blue-600 text-white shadow-lg' 
                        : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
                    }`}
                >
                    <BsUpcScan className="w-5 h-5" />
                </Button>
            </div>

            {scannerActive &&
                <div className="flex items-center justify-center mt-3">
                    <div className="w-max p-4 relative bg-gray-900 rounded-lg flex items-center justify-center">
                        <div className="absolute inset-0 bg-gradient-to-br from-gray-800 to-gray-900 rounded-lg">
                            
                        </div>
                        <div className="relative z-9 flex flex-col items-center text-white">
                            <div className="w-full flex justify-center align-center">
                                {/* <MobileInlineScanner 
                                    onScanned={handleScannedCallback}
                                /> */}
                                <MobileInlineScannerV2 
                                    onScanned={handleScannedCallback}
                                />
                            </div>
                            {/* <BsCamera className="w-12 h-12 mb-2 opacity-70" />
                            <p className="text-sm opacity-70">Kamera aktiv - Code scannen</p> */}
                            
                        </div>
                        
                        {/* Scan Frame */}
                        <div className="absolute z-10 inset-4 border-2 border-white opacity-50 rounded-lg">
                            
                        </div>
                        <div className="absolute z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32 h-0.5 bg-red-500 animate-pulse">
                        </div>
                    </div>
                </div>
                
            }


            {/* <div className="grid grid-cols-[1fr_1fr] gap-2">
                <div className="flex flex-col gap-4">
                    <TextField
                        name={'search'}
                        type="text"
                        // label={t(key + '_min')} 
                        label={t('searchInput')} 
                        variant="outlined" 
                        onChange={(event) => {
                            const value = event.target.value;
                            
                            setInputValue(value)
                        }}

                        fullWidth
                        value={inputValue}
                    />

                    <Button 
                        color="primary"
                        type="submit" 
                        variant={inputValue.length > 0 ? "contained" : "outlined"}
                        onClick={() => {
                            handleSubmit();
                        }}

                        sx={{
                            minHeight: "56px"
                        }}
                        fullWidth
                    >
                        {t("search")}
                    </Button>
                </div>
               

                <div className="w-full flex justify-center align-center">
                    <MobileInlineScanner 
                        onScanned={handleScannedCallback}
                    />
                </div>

            </div> */}
        </>

                  
    
    )

};

export default MultiScanForm;
